import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'
import { getProductsList, getWarehouses } from '../products/ProductsFunctions'

export const getInvoiceList = async (app, filter) => {
  let invoice_list = null 
  app.startLoadingIndicator()
  if (filter) {
    const { date } = filter
    await trackPromise (
      axios.get(app.API_URI + `/invoices/filter?dc_from=${date.date_created_from}&dc_to=${date.date_created_to}&dm_from=${date.date_modified_from}&=${date.date_modified_to}&status=${filter.show_invoice_status}`)
      .then(result => {
        invoice_list = result.data 
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
  } else {
    await trackPromise (
      axios.get(app.API_URI + '/invoices')
      .then(result => {
        invoice_list = result.data
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
  }
  return invoice_list
}

export const saveInvoice = async (app, inv, silent=false) => {
  if (inv.searchable_string) delete inv.searchable_string
  inv.signed_in = app.client.signed_in
  let invoice = null

  if (!silent) app.startLoadingIndicator("Saving Invoice")

  /** Its a new Invoice */
  if (!inv._id)
    await trackPromise (
      axios.post(app.API_URI + '/invoices', inv)
      .then(result => {
        if (result.data) {
          invoice = result.data
          if (!silent) app.stopLoadingIndicator()
        }
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
  /** It's an update */
  else
    await trackPromise (
      axios.put(app.API_URI + `/invoices?invoice_id=${inv._id}&la=${silent ? 0 : 1}`, inv)
      .then(result => {
        if (result.data) {
          invoice = result.data
          if (!silent) app.stopLoadingIndicator()
        }
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
  return invoice
}

export const deleteInvoice = async (app, invoice_id, silent=false) => {
  let delete_invoice = null
  if (!silent) app.startLoadingIndicator("Deleting Invoice")
  await trackPromise (
    axios.delete(app.API_URI + `/invoices?invoice_id=${invoice_id}`)
    .then(async (result) => {
      delete_invoice = result.status
      if (!silent) app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return delete_invoice
}

export const getCurrentVAT = async (app) => {
  let vat_value = null
  app.startLoadingIndicator("Reading VAT settings")
  await trackPromise (
    axios.get(app.API_URI + `/settings?user_id=global&field=vat`)
    .then(result => {
      vat_value = result.data.value
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return vat_value
}

export const getInvoiceDetailsFromCustomersAccounts = async (app, silent=false) => {
  let customers_details = null
  if (!silent) app.startLoadingIndicator()
  await trackPromise (
    axios.get(app.API_URI + '/customersaccounts/invoicesdetails')
    .then(result => {
      customers_details = result.data
      if (!silent) app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return customers_details 
}

export const getItemInventory = async (app, warehouse_id, ip) => {
  // ip - invoice particular
  let item_inventory = null
  app.startLoadingIndicator()
  await trackPromise (
    axios.get(app.API_URI + `/products?warehouse_id=${warehouse_id}`)
    .then(async (result) => {
      const pl = result.data
      const currentItem = pl.find(item => item._id === ip.item_id)
      // Know the item unit quantity on stock or inventory
      // of the current item base on the current item unit
      const currentItemUnit = currentItem.units
      .find(item => (item.description === ip.unit))

      // Exclude the current item unit asking for pull-out on first filter
      const outOfStock = (currentItem.units
      .filter(item => (item.description !== ip.unit && item.inventory > 0)).length === 0)

      item_inventory = { currentItem, inventory: currentItemUnit.inventory, out_of_stock: outOfStock }

      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return item_inventory
}

export const updateItemQuantity = async (app, warehouse_id, props) => {
  // Delete expirations array on the item it not need to be save
  delete props.ip.expirations
  // mode {-1: decrement 1: increment}
  let update_item_quantity = null
  await trackPromise(
    //axios.put(app.API_URI + '/products/' + warehouse_id + '/uq/' + props.mode, props.ip)
    axios.put(app.API_URI + `/products/uq?warehouse_id=${warehouse_id}&mode=${props.mode}`, props.ip)
    .then(result => { update_item_quantity = result.data })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return update_item_quantity
}

export const getInvoiceListSettings = async (app) => {
  let invoice_list_settings = null
  const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
  app.startLoadingIndicator()
  await trackPromise (
    axios.get(app.API_URI + `/settings?user_id=${user_id}&field=invoice_list`)
    .then(result => {
      invoice_list_settings = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return invoice_list_settings
}

export const saveInvoiceListSettings = async (app, setting) => {
  let save_ils = null
  const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
  app.startLoadingIndicator()
  await trackPromise (
    axios.put(app.API_URI + `/settings?user_id=${user_id}&field=invoice_list`, setting)
    .then(result => {
      save_ils = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return save_ils 
}

export const getInvoiceById = async (app, invoice_id) => {
  let invoice = null 
  app.startLoadingIndicator()
  await trackPromise (
    axios.get(app.API_URI + `/invoices?invoice_id=${invoice_id}`)
    .then(result => {
      invoice = result.data 
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return invoice
}

export { getProductsList, getWarehouses }